module.exports = __webpack_public_path__ + "img/adopting-from-mars.998097b8.jpg";